import React, {memo, ReactElement} from "react";
import {AutocompleteRenderInputParams} from "@mui/material";
import { StyledInput } from './AutocompleteInput.styles';

interface AutocompleteInputProps {
    params: AutocompleteRenderInputParams;
    label: string;
}

export const AutocompleteInput = memo((autocompleteInputProps: AutocompleteInputProps) => {
    const {InputLabelProps, InputProps, inputProps} = autocompleteInputProps.params;
    const { className, ...iProps } = inputProps;

    const endAdornmentProps = (InputProps.endAdornment as ReactElement).props;
    const isEndAdornmentDoubleComponent = endAdornmentProps
        && endAdornmentProps.children
        && endAdornmentProps.children.length === 2
        && endAdornmentProps.children[0] != null
        && endAdornmentProps.children[1] != null;

    return (
        <div ref={InputProps.ref} className="text-control" title={inputProps.value?.toString() ?? ""}>
            {/*<div className="text-control-label" {...InputLabelProps}>*/}
            <div className="text-control-label">
                {autocompleteInputProps.label}
            </div>
            <StyledInput
                className="text-control-input"
                isEndAdornmentDoubleComponent={isEndAdornmentDoubleComponent}
                type="text"
                {...iProps}
            />
            <div className="text-control-input-end-adornment">
                {InputProps.endAdornment}
            </div>
        </div>
    );
});